import styled from 'styled-components';

export const ChipGroupDiv = styled.div`
    display: flex;
    justify-content: ${props => props.align ? props.align : "center"};
    flex-wrap: wrap;
    && > * {
        margin: 0.25rem;
    }
`;